import f from "./index215.mjs";
import c from "./index216.mjs";
const l = ["duration", "easing", "delay"], p = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, y = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function b(e) {
  return `${Math.round(e)}ms`;
}
function A(e) {
  if (!e)
    return 0;
  const n = e / 36;
  return Math.round((4 + 15 * n ** 0.25 + n / 5) * 10);
}
function j(e) {
  const n = c({}, p, e.easing), u = c({}, y, e.duration);
  return c({
    getAutoHeightDuration: A,
    create: (o = ["all"], a = {}) => {
      const {
        duration: r = u.standard,
        easing: g = n.easeInOut,
        delay: s = 0
      } = a, d = f(a, l);
      if (process.env.NODE_ENV !== "production") {
        const t = (i) => typeof i == "string", m = (i) => !isNaN(parseFloat(i));
        !t(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !m(r) && !t(r) && console.error(`MUI: Argument "duration" must be a number or a string but found ${r}.`), t(g) || console.error('MUI: Argument "easing" must be a string.'), !m(s) && !t(s) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof a != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(d).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(d).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((t) => `${t} ${typeof r == "string" ? r : b(r)} ${g} ${typeof s == "string" ? s : b(s)}`).join(",");
    }
  }, e, {
    easing: n,
    duration: u
  });
}
export {
  j as default,
  y as duration,
  p as easing
};
